module.exports = __webpack_public_path__ + "static/media/background-login.d707884b.jpg";